import React from 'react';
import ChartComponent, { Chart } from 'react-chartjs-2';
import { AutoSizer } from 'react-virtualized';
import { getColorStart, getColorAverage, getColorEnd } from "./StyledDoughnutChart";
import ChartDataLabels from 'chartjs-plugin-datalabels';

var clickHandle = function(event) {
    console.log(event);
}

Chart.defaults.StyledStackedBar = Chart.defaults.bar;
Chart.controllers.StyledStackedBar = class StyledStackedBar extends Chart.controllers.bar {
    constructor(chart, datasetIndex) {
        if (chart.options.print) {
            chart.options.animation = false;
        }

        console.log(chart.data.datasets);

        // Automatic colors
        if (!chart.data.datasets[datasetIndex].backgroundColor) {
            if (chart.options.print) {
                let [r, g, b] = getColorAverage(datasetIndex, chart.data.datasets.length);
                //chart.data.datasets[datasetIndex].backgroundColor = `rgb(${r},${g},${b})`;
                if (datasetIndex % 2 == 0) {
                    chart.data.datasets[datasetIndex].backgroundColor = 'rgba(72,134,255,1)';
                } else {
                    chart.data.datasets[datasetIndex].backgroundColor = 'rgba(119,111,235,1)';
                }
            } else {
                let [r1, g1, b1] = getColorStart(datasetIndex, chart.data.datasets.length);
                let [r2, g2, b2] = getColorEnd(datasetIndex, chart.data.datasets.length);
    
                const gradient = chart.ctx.createLinearGradient(0, 0, 0, chart.canvas.height);
                //gradient.addColorStop(0, `rgb(${r1},${g1},${b1})`);
                //gradient.addColorStop(1, `rgb(${r2},${g2},${b2})`);
                if (datasetIndex % 2 == 0) {
                    gradient.addColorStop(0, 'rgba(72,134,255,.9)');
                    gradient.addColorStop(1, 'rgba(72,134,255,0.4)');
                } else {
                    gradient.addColorStop(0, 'rgba(119,111,235,.9)');
                    gradient.addColorStop(1, 'rgba(119,111,235,0.4)');
                }
    
                chart.data.datasets[datasetIndex].backgroundColor = gradient;
            }
        }
        if (!chart.data.datasets[datasetIndex].borderColor) {
            let [r, g, b] = getColorAverage(datasetIndex, chart.data.datasets.length);
            chart.data.datasets[datasetIndex].borderColor = `rgb(${r},${g},${b})`;
        }
        
        // size
        chart.data.datasets[datasetIndex].barPercentage= 0.8;
        chart.data.datasets[datasetIndex].categoryPercentage= 0.9;
        //chart.data.datasets[datasetIndex].minBarLength= 2;

        super(chart, datasetIndex);
    }
}

class StyledStackedBarChart extends React.Component {
    render() {
        if (!this.props.data)
            return null;

        return (
            <AutoSizer disableHeight={!!this.props.height}>
                {({ width, height }) => (
                    <div className="styledWrapper__decorated-shifted" style={{ width, height }}>
                        <ChartComponent type="StyledStackedBar"
                                        options={this.props.options}
                                        data={this.props.data}
                                        width={width}
                                        height={height || this.props.height}
                                        redraw />
                    </div>
                )}
            </AutoSizer>
        );
    }
}

export const _Chart = Chart;
export default StyledStackedBarChart;
